import cn from 'classnames'
import styles from './alert-card.module.scss'

const SEVERITY_LABELS = {
    info: 'Info',
    warn: 'Warning',
    alert: 'Alert'
}

/**
 * @param {{
 *   severity: 'info'|'warn'|'alert',
 *   title: string,
 *   body?: string,
 *   timestamp?: string,
 *   unread?: boolean,
 *   onClick?: () => void
 * }} props
 */
export function AlertCard({severity, title, body, timestamp, unread = false, onClick}) {
    const role = severity === 'alert' && unread ? 'alert' : 'status'
    const Element = onClick ? 'button' : 'article'
    return (
        <Element
            type={onClick ? 'button' : undefined}
            onClick={onClick}
            className={cn(styles.card, styles[severity], {[styles.unread]: unread, [styles.clickable]: !!onClick})}
            role={role}
        >
            <header className={styles.header}>
                <span className={styles.severity}>{SEVERITY_LABELS[severity] || severity}</span>
                {timestamp && <time className={styles.time} dateTime={timestamp}>{formatTimestamp(timestamp)}</time>}
            </header>
            <h3 className={styles.title}>{title}</h3>
            {body && <p className={styles.body}>{body}</p>}
        </Element>
    )
}

function formatTimestamp(iso) {
    const date = new Date(iso)
    const now = Date.now()
    const diffMin = Math.round((now - date.getTime()) / 60_000)
    if (diffMin < 1) return 'just now'
    if (diffMin < 60) return `${diffMin}m`
    const diffHr = Math.round(diffMin / 60)
    if (diffHr < 24) return `${diffHr}h`
    return date.toLocaleDateString()
}
